import { Grid, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import OrderDetailTab from './OrderDetailTab'
import { AutoCompleter } from '../../AutoCompleter/AutoCompleter'
import { plannerOT } from '../../../const/locationPaths'
import { HelpIconTooltip } from '../../_EOS/Tooltip/HelpIconTooltip'

interface OrderDetailViewerProps {
  referenceList: string[]
}

export function OrderDetailViewer({ referenceList }: OrderDetailViewerProps) {
  const [expanded, setExpanded] = useState('panel_0')
  const [referenceId, setReferenceId] = useState<number>(0)
  const [loader, setLoader] = useState<boolean>(false)
  const [mensaje, setMensaje] = useState<string>('')

  const handleChangeAutoCompleter = (e: any) => {
    if (e.target.value !== '') {
      setLoader(true)
      setTimeout(() => {
        if (
          referenceList.filter((ref) => ref.includes(e.target.value)).length > 0
        ) {
          setReferenceId(e.target.value)
          setMensaje('')
        } else {
          setMensaje('No encontrado')
          setReferenceId(0)
        }

        setLoader(false)
      }, 1000)
    } else {
      setMensaje('Debe ingresar N° pedido')
      setReferenceId(0)
    }
  }

  return referenceList.length > 1 ? (
    <Fragment>
      <Grid
        container
        direction='row'
        spacing={2}
        justifyContent='flex-end'
        alignItems='center'
      >
        <Grid item xs={12} sm={12} md={8}>
          <Typography>Buscar Por: </Typography>
          <AutoCompleter
            item={referenceList.map((item: any) => {
              return {
                value: item.split('/')[1]
              }
            })}
            nameList={'N° Pedido'}
            labelList={'N° Pedido'}
            handleChange={handleChangeAutoCompleter}
            isLoader={loader}
            variant='outlined'
          />
          <HelpIconTooltip message='Puede hacer click para recibir sugerencias' />
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        spacing={2}
        justifyContent='center'
        alignItems='center'
      >
        <Grid item xs={12} sm={12} md={3}>
          <span style={{ color: 'red' }}>{mensaje}</span>
        </Grid>
      </Grid>

      {referenceList.map((item, index) =>
        OrderDetailTab(
          item,
          index,
          expanded,
          setExpanded,
          plannerOT,
          referenceId
        )
      )}
    </Fragment>
  ) : (
    <Fragment>
      {referenceList.map((item, index) =>
        OrderDetailTab(item, index, expanded, setExpanded, 'planner/Order')
      )}
    </Fragment>
  )
}
